<template>
    <div class="ui required field">
        <label>Charity</label>
        <div class="ui fluid selection dropdown">
            <input type="hidden" name="charity_id" v-bind:value="charityId">
            <i class="dropdown icon"></i>
            <div class="default text">Charity</div>
            <div class="menu">
                <div class="item" v-for="charity in charities" :key="charity.id" v-bind:data-value="charity.id">
                    {{ charity.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            charities: [],

            dropdown: null
        }
    },

    props: {
        charityId: Number,
    },

    /**
     * Prepare the component (Vue 2.x).
     */
    mounted() {
        this.prepareComponent();
    },

    updated() {
        this.dropdown.dropdown();
    },

    methods: {
        prepareComponent() {
            this.getCharities();

            this.dropdown = $(this.$el).find('.ui.selection.dropdown');
        },
        
        getCharities() {
            axios.get('//' + Laravel.apiHost + '/charities')
                .then(response => {
                    this.charities = response.data;
                    
                    this.$nextTick(() => {
                        this.dropdown.dropdown('set selected', this.charityId);
                    });
                });
        }
    }
}
</script>